import React from 'react';
import Formulario from "./components/Formulario";
import Lista from "./components/Lista";

const Viatico = props => {
    const path = props.match.path;
    return (
        <React.Fragment>
            {(path === '/viatico/new' || path.indexOf('/viatico/edit') === 0) && <Formulario {...props}/>}
            {path === '/viatico/list' && <Lista {...props}/>}
        </React.Fragment>
    );
};

export default Viatico;
